export enum DataRouting {
  Appeals = 'appeals'
}
